import { writable, get } from "svelte/store";

import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import FlagHelper from "../../Helpers/FlagHelper";
import MapStore from "../../Map/Store";
import VisibilityState from "../../Map/Enums/VisibilityState";
import { Paint } from "../../Map/MapLayerStyles";

import MapLayerManager from "../../Map/MapLayerManager";
import MapLayerGroup from "../../Map/Enums/MapLayerGroup";

import API from "../../API/API";
import PopupStore from "../../Map/Popup/PopupStore";

const HotspotsStore = {
	config: {

	},
	meta: {
		loadState: writable(LoadState.INIT),
		layers: [],
		visible: writable(false),
		lastUpdated: writable(0),
		visibility: {
			tanker: writable(true),
			fishing: writable(true),
			cargo: writable(true)
		}
	},
	results: {
		tanker: writable(GeoHelper.emptyGeoJson()),
		fishing: writable(GeoHelper.emptyGeoJson()),
		cargo: writable(GeoHelper.emptyGeoJson())
	},
	actions: {
		init: () => {
			if (get(HotspotsStore.meta.loadState) !== LoadState.INIT) {
				return;
			}
			HotspotsStore.meta.loadState.set(LoadState.LOADING);
			console.log("Loading Hotspots...");

			API.get("rois/sts-hotspots").then((results) => {
				MapStore.helpers.addDataLayer("hotspots_sts_tanker", "fill", {}, Paint.hotspots.orange, results.Tanker, HotspotsStore.meta.layers);
				MapStore.helpers.addDataLayer("hotspots_sts_cargo", "fill", {}, Paint.hotspots.green, results.Cargo, HotspotsStore.meta.layers);
				MapStore.helpers.addDataLayer("hotspots_sts_fishing", "fill", {}, Paint.hotspots.blue, results.Fishing, HotspotsStore.meta.layers);

				MapLayerManager.addLayerGroup(MapLayerGroup.STS_HOTSPOTS, [
					"hotspots_sts_tanker", "hotspots_sts_cargo", "hotspots_sts_fishing"
				], [
					"hotspots_sts_tanker", "hotspots_sts_cargo", "hotspots_sts_fishing"
				]);

				HotspotsStore.results.tanker.set(results.Tanker);
				HotspotsStore.results.cargo.set(results.Cargo);
				HotspotsStore.results.fishing.set(results.Fishing);

				const setupPopups = (layer) => {
					const map = MapStore.helpers.getMap();
					const enter = (e) => {
						const props = e.features[0].properties;
						// const coords = e.features[0].geometry.coordinates;
						const coords = [e.lngLat.lng, e.lngLat.lat];

						const flagLabels = JSON.parse(props.flag_labels);
						const flagValues = JSON.parse(props.flag_values);

						// console.log(flagLabels, flagValues);

						let html = "";
						html += "<b>Ship-to-ship Hotspot:</b>";
						html += "<table>";
						html += `<tr>
									<td><b>Avg Time:</b></td>
									<td>${props.time} hrs</td>
								</tr>`;
						html += `<tr>
									<td><b>Total Events:</b></td>
									<td>${props.total}</td>
								</tr>`;
						for (let i = 0; i < flagLabels.length; i++) {
							let useFlag = true;
							const flagCode = FlagHelper.toFlagCountryCode(flagLabels[i]);
							let countryName = FlagHelper.toFlagCountryName(flagLabels[i]);
							if (flagLabels[i] === "Other") {
								useFlag = false;
								countryName = "Other";
							}
							html += `<tr>
										<td>
											` + ((useFlag) ? `<div class="flag flag-${flagCode}"></div>` : "") + `
											<span>${countryName}</span>
										</td>
										<td>${flagValues[i]}</td>
									</tr>`;
						}
						html += "</table>";
						PopupStore.actions.customHtml(html, 300, coords, true);
					};
					const move = enter;
					const leave = (e) => {
						PopupStore.actions.custom({}, null, false);
					};
					map.on("mouseenter", layer, (e) => {
						enter(e);
					});
					map.on("mousemove", layer, (e) => {
						move(e);
					});
					map.on("mouseleave", layer, (e) => {
						leave(e);
					});
				};
				setupPopups("hotspots_sts_tanker");
				setupPopups("hotspots_sts_cargo");
				setupPopups("hotspots_sts_fishing");

				HotspotsStore.meta.loadState.set(LoadState.LOADED);
				HotspotsStore.meta.lastUpdated.set(Date.now());
			});
		},

		updateVisibility: () => {
			const map = MapStore.helpers.getMap();
			if (map) {
				if (get(HotspotsStore.meta.loadState) !== LoadState.LOADED) {
					return;
				}

				const visible = get(HotspotsStore.meta.visible);
				const tankerVisibility = get(HotspotsStore.meta.visibility.tanker);
				const fishingVisibility = get(HotspotsStore.meta.visibility.fishing);
				const cargoVisibility = get(HotspotsStore.meta.visibility.cargo);
				map.setLayoutProperty("hotspots_sts_tanker", "visibility", (visible && tankerVisibility) ? VisibilityState.VISIBLE : VisibilityState.NONE);
				map.setLayoutProperty("hotspots_sts_cargo", "visibility", (visible && cargoVisibility) ? VisibilityState.VISIBLE : VisibilityState.NONE);
				map.setLayoutProperty("hotspots_sts_fishing", "visibility", (visible && fishingVisibility) ? VisibilityState.VISIBLE : VisibilityState.NONE);
			}
		}
	}
};

export default HotspotsStore;
